import {users} from '@mep/pae-commons';
import {Input} from 'antd';
import PropTypes from 'prop-types';
import React, {memo, useMemo} from 'react';

import ActorsSelect from '@/modules/actors/components/ActorsSelect';
import CommercialRegisterSelect from '@/modules/configuration/components/CommercialRegisterSelect';
import DPJNotariesSelect from '@/modules/configuration/components/DPJNotariesSelect';
import HistorianOfficesSelect from '@/modules/configuration/components/HistorianOfficesSelect';
import NotariesSelect from '@/modules/configuration/components/NotariesSelect';
import OrganizationSelect from '@/modules/configuration/components/OrganizationSelect';

const {USER_TYPES} = users;

const UserOfficeSelection = ({userType, onChange, filters, ...rest}) => {

  const content = useMemo(() => {
    switch (userType) {
      case USER_TYPES.NOTARY_DPJ: {
        return <DPJNotariesSelect onChange={onChange} filters={filters} {...rest}/>;
      }
      case USER_TYPES.NOTARY: {
        return <NotariesSelect onChange={onChange} filters={filters} {...rest}/>;
      }
      case USER_TYPES.HISTORIAN: {
        return <HistorianOfficesSelect onChange={onChange} {...rest}/>;
      }
      case USER_TYPES.COMMERCIAL_REGISTER: {
        return <CommercialRegisterSelect filters={filters} onChange={onChange} {...rest}/>;
      }
      case USER_TYPES.FUNCTIONARY_ORGANIZATION: {
        return <OrganizationSelect onChange={onChange} {...rest}/>;
      }
      case USER_TYPES.ONAT_USER: {
        return <ActorsSelect onChange={onChange} {...rest}/>;
      }
      default: {
        return <Input {...rest} onChange={onChange}/>;
      }
    }
  }, [filters, onChange, rest, userType]);

  return (
    <div>{content}</div>
  );
};

UserOfficeSelection.propTypes = {
  value: PropTypes.string,
  filters: PropTypes.any,
  onChange: PropTypes.func,
  userType: PropTypes.string,
};

export default memo(UserOfficeSelection);
